import {environment} from './constants-enumerate';

const accessibilityMixin = (superClass) => {
  /**
   * @summary AccessibilityMixin
   * @extends {superClass}
   */
  class AccessibilityMixin extends superClass {
    /**
     * constructor
     */
    constructor(...args) {
      super(...args);
    }

    /**
     * @param {Event} e
     */
    skipNavTo(e) {
      e.preventDefault();
      const id = e.currentTarget.hash.slice(1);
      const target = this.shadowRoot.getElementById(id);
      target.focus();
    }

    /**
     *
     * @memberof AccessibilityMixin
     */
    async connectedCallback() {
      super.connectedCallback();

      await this.updateComplete;
      // Check for the polyfill:
      if (window.applyFocusVisiblePolyfill !== null) {
        window.applyFocusVisiblePolyfill(this.shadowRoot);
      }

      this.enteractiveElements = this.shadowRoot.querySelectorAll('.enteractive');
      if (!this.enteractiveElements) return;

      this.enteractiveElements.forEach((elem) => {
        elem.addEventListener('keyup', (e) => {
          if (e.keyCode === 13) {
            elem.click();
          }
        });
      });

      // Make checkbox focus back on itself after pressing Enter
      this.checkboxFocusElements = this.shadowRoot.querySelectorAll('.enteractive-checkbox');
      if (!this.checkboxFocusElements) return;

      this.checkboxFocusElements.forEach((elem) => {
        elem.addEventListener('keypress', (e) => {
          if (e.keyCode === 13) {
            elem.click();
            elem.focus();
          }
        });
      });

      this.resetFocus = this.shadowRoot.querySelector('.reset-focus');
      if (!this.resetFocus) return;

      this.resetFocus.addEventListener('keydown', (e) => {
        if (e.shiftKey && e.keyCode === 9) {
          return;
        } else if (e.keyCode === 9) {
          this.modalFocus.focus();
        }
      });

      this.topFocus = this.shadowRoot.getElementById('top-focus');
      if (!this.topFocus) return;

      this.topFocus.addEventListener('keydown', (e) => {
        if (e.shiftKey && e.keyCode === 9) {
          e.preventDefault();
          this.resetFocus.focus();
        }
      });
    }

    /**
     *
     */
    async firstUpdated() {
      super.firstUpdated();

      if (environment.IN_APP) {
        this.rmTabindexElements = this.shadowRoot.querySelectorAll('.rm-tabindex');
        this.rmTabindexElements.forEach((elem) => {
          elem.removeAttribute('tabindex');
        });
        this.addTabindexElements = this.shadowRoot.querySelectorAll('.add-tabindex');
        this.addTabindexElements.forEach((elem) => {
          elem.setAttribute('tabindex', '0');
        });
      }

      this.modalFocus = this.shadowRoot.getElementById('modal-focus');
      if (!this.modalFocus) return;

      await this.updateComplete;
      this.modalFocus.focus();
    }
  }

  return AccessibilityMixin;
};

export {
  accessibilityMixin
};
